// extracted by mini-css-extract-plugin
export default {"chevron":"app-registrationReports-ReportPicker-module__jsWuJeMPNZ2IKAfjd1gY"};